const brItemPrice = {
  itemPrice: {
    label: {
      name: 'Name',
      selectItem: 'Select an item',
      selectedItem: 'Selected item',
      in: 'in',
      basePrice: 'Base price',
      comboPrice: 'Combo price',
      comboEnabler: 'Enable combo?',
    },

    hints: {
      delete: 'Do you really want to delete the price of this item for this table?',
      basePriceIsRequired: 'Base price is required',
    },

    action: {
      addPrice: 'Add price',
      editPrice: 'Edit price',
      comboIsEnabled: 'Combo enabled',
      comboIsNotEnabled: 'Combo disabled',
      delete: 'Delete item price',
      cancel: 'Cancel',
    },

    messages: {
      successfullyCreated: 'Item price created successfully',
      successfullyUpdated: 'Item price updated successfully',
      successfullyDeleted: 'Item price removed successfully',
    },
  },
};

export default brItemPrice;
